
const Helper = () => {
    const menuItemHeightCalc = (arr,data) => {
        // console.log('menuItemHeightCalc-------', arr);
        let height = null;
        arr.forEach(element => {
            // height += element.clientHeight + 10

        if(element.parentElement.classList.contains('underTheCounterPedestalsCategory')){
            height += element.clientHeight + 18;
        }
        else if(element.parentElement.classList.contains('microwaveDrawerOvensCategory') && data.menuItemLength == 1){
            height += element.clientHeight + 35;
        }
        else if(element.parentElement.classList.contains('microwaveDrawerOvensCategory')){
            height += element.clientHeight + 15;
        }
        else{
        height += element.clientHeight + 10
        }

        });
        return height;
    }
    const menuItemFindInCart = (title, arr) => {
        let itemPresentInCart = false;
        // console.log('menuItemHeightCalc-------', arr);
        //  arr.forEach(element => {
        //     console.log('menuItemFindInCart', element.title);
        //     console.log('menuItemFindInCart', ele);
        //     if( ele == element.title){
        //         return  element;
        //     } 
        // }); 

        // console.log('isObjectInArray------', arr.find((ele)=> isObjectInArray(ele, title)));
        itemPresentInCart = arr.find((ele) => isObjectInArray(ele, title));
        if (itemPresentInCart != undefined) {
            return true;
        } else {
            return false;
        }
        // console.log('menuItemFindInCart---------', itemPresentInCart);
        // return itemPresentInCart;

    }

    function isObjectInArray(ele, string) {
        return ele.title === string;
    }

    return {
        menuItemHeightCalc,
        menuItemFindInCart
    }

}

export default Helper;